/*
 * This code is protected by intellectual property rights.
 * Dr. Ing. h.c. F. Porsche AG owns exclusive rights of use.
 * © 2017-2026, Dr. Ing. h.c. F. Porsche AG.
 */

import { CommonModule } from '@angular/common'
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core'
import { FormsModule } from '@angular/forms'
import { TranslatePipe } from '@ngx-translate/core'
import { PidxTimerLabelComponent } from './pidx-timer-label.component'
import { PorscheDesignSystemModule } from '@porsche-design-system/components-angular'

@NgModule({
  declarations: [PidxTimerLabelComponent],
  imports: [CommonModule, FormsModule, TranslatePipe, PorscheDesignSystemModule],
  exports: [PidxTimerLabelComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class PidxTimerLabelModule {}
